// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper--2OmP9FPL {\n  padding: 0 12px;\n  display: grid;\n  grid-gap: 10px;\n  gap: 10px;\n  overflow: hidden;\n}\n\n.varList--3l5IdJ_- {\n  overflow: auto;\n  display: grid;\n}\n\n.dangerText--2b9T90r_ {\n  padding-left: 3px;\n  padding-right: 3px;\n  color: var(--theme-red-color);\n  font-weight: normal;\n  background-color: var(--theme-red-background);\n  border-radius: 2px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "wrapper--2OmP9FPL",
	"varList": "varList--3l5IdJ_-",
	"dangerText": "dangerText--2b9T90r_"
};
export default ___CSS_LOADER_EXPORT___;
